module.exports = __webpack_public_path__ + "img/color_wheel.caa0dee8.png";